import { createContext } from 'react'
import RootStore from 'stores/RootStore'

// mobx-react v10 dropped the legacy `Provider`/`inject`/`MobXProviderContext`
// APIs, so store injection is now implemented with a plain React context.
export type RootStoreContextValue = {
  rootStore?: RootStore
}

// Default value matches the empty object mobx-react's `MobXProviderContext`
// used to default to, so components rendered outside a Provider behave the
// same way they did before (destructuring an absent key yields `undefined`).
const RootStoreContext = createContext<RootStoreContextValue>({})

export default RootStoreContext
